export function SkeletonCard({ height = 120 }) {
  return <div style={{ ...styles.skeleton, height }} />;
}

export function SkeletonRow() {
  return (
    <div style={styles.row}>
      <div style={{ ...styles.skeleton, width: 40, height: 40, borderRadius: '50%' }} />
      <div style={{ flex: 1 }}>
        <div style={{ ...styles.skeleton, height: 14, width: '60%', marginBottom: 8 }} />
        <div style={{ ...styles.skeleton, height: 10, width: '40%' }} />
      </div>
    </div>
  );
}

export function SkeletonPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ ...styles.skeleton, height: 40, width: '50%' }} />
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {[1,2,3,4,5,6].map(i => <div key={i} style={{ ...styles.skeleton, height: 60, flex: '1 1 80px' }} />)}
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ ...styles.skeleton, height: 200, flex: 1 }} />
        <div style={{ ...styles.skeleton, height: 200, flex: 1 }} />
      </div>
      <div style={{ ...styles.skeleton, height: 300 }} />
    </div>
  );
}

const styles = {
  skeleton: {
    background: 'linear-gradient(90deg, #1a1a2e 25%, #252540 50%, #1a1a2e 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s ease-in-out infinite',
    borderRadius: 12,
  },
  row: { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0' },
};

// Add shimmer keyframe to document
if (typeof document !== 'undefined' && !document.getElementById('skeleton-style')) {
  const style = document.createElement('style');
  style.id = 'skeleton-style';
  style.textContent = '@keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }';
  document.head.appendChild(style);
}
